import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { authProvider } from './authProvider';
import { Button } from 'reactstrap';
import { loadTheme } from '@fluentui/react';
import { NettechTheme } from './themes/NettechTheme.js'

loadTheme(NettechTheme)
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <AzureAD provider={authProvider} forceLogin={true}>
        {
            ({ login, logout, authenticationState, error, accountInfo }) => {
                console.log(authenticationState);
                switch (authenticationState) {
                    case AuthenticationState.Authenticated:
                        return (
                            <BrowserRouter basename={baseUrl} forceRefresh={true}>
                                <App />
                            </BrowserRouter>);
                    case AuthenticationState.Unauthenticated:
                        return (
                            <div>
                                {error && <p>An error occurred, please try again!</p>}
                                <Button onClick={login}>Login</Button>
                            </div>
                        );
                    case AuthenticationState.InProgress:
                        return (<div><p>Login in progress...</p></div>);
                    default:
                        return (<div><p>Please contact the developers.  This shouldn't happen</p></div>);
                }
            }
        }
        
    </AzureAD>,
    rootElement);

registerServiceWorker();

